import React, { useState } from 'react';
import './Login.scss';
import Input from '../forms/inputs/Input';
import InputPassword from '../forms/inputs/Input.password';
import GraphQlClient from '../services/graphql';

import {Redirect, Link} from 'react-router-dom';
import Button from '../forms/buttons/Button';
import { Subject } from 'rxjs';
import historyState from "../services/history.state";
import { useTranslation } from 'react-i18next';
import CookieSetter from "../services/cookieSetter";
import {useLazyQuery} from "@apollo/client";
import gqlSchemaLibrary from "../services/graphql.schemas";
import AuditTrail, {PAGES} from "../services/interactions/audit.trail";
import {PageViewLog} from "../services/interactions/page.view";

function LoginComponent ({toaster, match, setUser, history, setRedirectExpired}) {
    const [emailChangedSub] = useState(new Subject());
    const [username, _setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [isLoggedIn, setIsLoggedIn] = useState(false);
    const [isLockedAccount, setIsLockedAccount] = useState(false);
    const [isExpired, setIsExpired] = useState(false);

    const [logo, setLogo] = useState('');
    const [error, setError] = useState(false);
    const [currentUser, setCurrentUser] = useState(null);
     const { t } = useTranslation(['auth']);

     const [getRedirectHash] = useLazyQuery(gqlSchemaLibrary.user.query.getURIFromHash, {
      onCompleted: (data) => {
          if (data.getURIFromHash) {
              history.push(data.getURIFromHash);
              setUser(currentUser);
          } else {
              setRedirectExpired(true);
          }
      },
      onError: (err) => {
          setUser(currentUser);
      },
      fetchPolicy: 'cache-and-network'
    });

    const submitLogin = (e) => {
        e.preventDefault();
        if (!username || !password) {
            AuditTrail.sendLog(PAGES.LOGIN, {event: 'onClick', action: 'login failed', message: 'empty credentials'});
            setError(true);
            return;
        }
        AuditTrail.sendLog(PAGES.LOGIN, {event: 'onClick', action: 'button login'});
        setError(false);
        setIsLockedAccount(false);
        setIsExpired(false);
        CookieSetter.deleteCookie('temp_unit');
        GraphQlClient.login(username, password)
        .then(meUser => {
            AuditTrail.sendLog(PAGES.LOGIN, {event: 'onSubmit', action: 'login success'});
            const hash = historyState.getStateFromSearch.redirect;
            if (hash) {
                setCurrentUser(meUser);
                getRedirectHash({
                    variables: {
                        hash: hash
                    }
                });
            } else {
                setUser(meUser);
            }
        })
        .catch(e => {
            console.error('Login Error: ', e);
            AuditTrail.sendLog(PAGES.LOGIN, {event: 'onSubmit', action: 'login failed', message: e.message});
            if (e.message === 'locked account'){
                setIsLockedAccount(true)
            } else if(e.message === 'password expired'){
                setIsExpired(true);
            }
            setError(true);
        })
    }

    const setUsername = (value) => {
        _setUsername(value);
        setError(false);
        const _em = value.split('@');
        if(_em[1]){
            const _dom = _em[1];
            const isDomain = _dom.split('.').length > 1;
            if(isDomain){
                emailChangedSub.next(_dom);
            }
        }
    }

    const loginStatusMessage = () => {
        let spanText = '';
        let linkText = t('forgot-password');
        if (isLockedAccount) {
            spanText = t('locked-account');
            linkText = '';
        }
        if (isExpired) {
            spanText = t('password-expired');
            linkText = t('reset-password');
        }
        return (
            <>
                <span>{spanText}</span>
                <Link className={"tertiary"} to={"/password"}>{linkText}</Link>
            </>
        )
    }

    return (
        <div id="Login">
            <form onSubmit={submitLogin}>
                <div className="logoHold">
                    {
                        logo ? 
                        <img className="logoClient" src={logo} alt="Rush"/>
                        : ''
                    }
                    <img className={`logo ${logo ? '_goaway' : ''}`} src="https://logoassets.s3.us-east-2.amazonaws.com/cherish-logo-dark-trim_updated_01.png" alt="Cherishhealth Logo"/>
                </div>
                <Input 
                label={t('email-address')}
                placeholder={t('email-address')}
                value={username}
                onChange={setUsername}
                error={error}
                event={PAGES.LOGIN}
                />
                <InputPassword 
                label={t('pwd')}
                placeholder={t('pwd')}
                error={error}
                value={password}
                onChange={setPassword}
                event={PAGES.LOGIN}
                />
                <Button type={'submit'} className={`${error ? 'error' : ''}`} >
                    <span>{error ? t('invalid-credentials') :t('enter')}</span>
                </Button>
                {loginStatusMessage()}
                {
                    logo ? 
                    <div className="__poweredBy">
                        <span>{t('by')}</span>
                        <img className={`logo`} src="https://logoassets.s3.us-east-2.amazonaws.com/cherish-logo-dark-trim_updated_01.png" alt="Cherishhealth Logo"/>
                    </div>
                    : ''
                }
            </form>
        </div>
    )
}

export default PageViewLog(LoginComponent);
